<template>
  <validation-provider
    name="address"
    rules="required"
    v-slot="{ errors }">
    <div
      :class="{
        'form-control': true,
        'is-select': true,
        'is-invalid': errors.length,
        'vs-wrap-text': true
      }">
      <v-select
        :options="addresses"
        v-model="address_id"
        :disabled="disabled"
        :reduce="(address) => address.id"
        placeholder="Wybierz adres"
        :searchable="true"
        label="street">
        <template slot="no-options">
          <template v-if="!emptyResults">Trwa wyszukiwanie&hellip;</template>
          <template v-else>Brak adresów przypisanych do klienta&hellip;</template>
        </template>
        <template
          slot="option"
          slot-scope="option">
          <div class="d-center">
            <template v-if="option.house_number">
              {{ option.street }} {{ option.building_number }} / {{ option.house_number }}, {{ option.post_code }}, {{ option.city }}<br>
            </template>
            <template v-else>
              {{ option.street }} {{ option.building_number }}, {{ option.post_code }}, {{ option.city }}<br>
            </template>
            <small>{{ option.name }}, {{ option.surname }}</small>
          </div>
        </template>
        <template
          slot="selected-option"
          slot-scope="option">
          <div class="selected d-center">
            <template v-if="option.house_number">
              {{ option.street }} {{ option.building_number }} / {{ option.house_number }}, {{ option.post_code }}, {{ option.city }}<br>
            </template>
            <template v-else>
              {{ option.street }} {{ option.building_number }}, {{ option.post_code }}, {{ option.city }}<br>
            </template>
            <small>{{ option.name }}, {{ option.surname }}</small>
          </div>
        </template>
      </v-select>
    </div>
    <div class="invalid-feedback">
      {{ errors[0] }}
    </div>
  </validation-provider>
</template>

<script>
import FormUtils from './../../../utils/FormUtils';

export default {
  name: 'order-address-select',
  props: [
    'disabled'
  ],
  data () {
    return {
      address_id: null,
      addresses: [],
      emptyResults: false,
      selectedAddress: null,
      selectedCustomer: null,
      loadError: false
    }
  },
  mounted () {
    this.$bus.$on('order-update-address-list', this.loadCustomerAddressesData);
    this.$bus.$on('client-delivery-address-added', this.loadCustomer);
  },
  methods: {
    loadCustomerAddressesData(customerAddresses = [], addressID = null) {
      this.address_id = addressID;
      this.addresses = customerAddresses;
      if (this.addresses.length === 0) {
        this.emptyResults = true;
        return;
      }

      if (this.addresses.length === 1) {
        this.address_id = this.addresses[0].id;
      }
    },
    loadCustomer (customerID, addressID = null, paymentID = null) {
      FormUtils.loadAdditionalData(this, {
        method: 'get',
        endpoint: '/api/contacts/item/' + parseInt(customerID, 10),
        outputKey: 'selectedCustomer',
        errorKey: 'loadError',
        wrapResponseIntoArray: false,
        successAction: (response) => {
          this.customer_id = parseInt(customerID, 10);

          setTimeout(() => {
            this.address_id = addressID;
            this.addresses = this.selectedCustomer.addresses;
            if (this.selectedCustomer.addresses.length === 0) {
              this.emptyResults = true;
            }
            this.$bus.$emit('order-update-payment-list', response.payments, paymentID);
          }, 0);
        }
      });
    }
  },
  beforeDestroy() {
    this.$bus.$off('order-update-address-list', this.loadCustomerAddressesData);
    this.$bus.$off('client-delivery-address-added', this.loadCustomer);
  }
}

</script>
